<template>
<v-container>
  <v-row class="text-center">
    <v-col>
      <h1 :class="[$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1']">
        News & Insights
      </h1>
      <v-divider class="mx-auto my-2" style="max-width: 100px; border-width: 2px" />
      <p>Be part of something bigger, and smarter</p>
    </v-col>
  </v-row>
  <v-row>
    <v-col v-for="(i, index) in newsList" :key="index" cols="12">
      <news-card :cardData="i" />
    </v-col>
  </v-row>
</v-container>
</template>

<script>
import newsCard from '@/components/NewsCard';

export default {
  name: 'News',
  components: {
    newsCard,
  },
  data: () => ({
    newsList: [],
  }),
  methods: {
    fetchNews() {
      this.$prismic.client.query(
        this.$prismic.Predicates.at('document.type', 'news'), { lang: this.$i18n.locale },
      ).then((document) => {
        this.newsList = document.results;
      });
    },
  },
  created() {
    this.fetchNews();
  },
};
</script>

<style scoped>

</style>
